import { useFileNavigator } from "../../../context/FileNavigator";
import SolarFolderWithFilesBold from "../../icons/SolarFolderWithFilesBold";

const FileNavigatorButton = () =>{
 
    const { dispatchFN } = useFileNavigator();

    return (
        <div className="pc-h-item ">
            <span className="pc-head-link ms-0 cursor-pointer"
                onClick={()=>dispatchFN({type:'SET_SHOW_FN', payload:true})}>
                <SolarFolderWithFilesBold/>
            </span>
        </div>
    )
}  

export default FileNavigatorButton;